import styled from "styled-components";
import { Field } from "react-final-form";

interface Country {
  id: number;
  iso: string;
  name: string;
}

interface CountrySelectProps {
  countries: Country[];
  error?: string;
  placeholder?: string;
  name?: string;
}

export const CountrySelect = ({
  countries,
  error,
  placeholder = "Select a country",
  name = "country",
  ...rest
}: CountrySelectProps) => {
  return (
    <Field
      name={name}
      initialValue=""
      render={({ input, meta }) => (
        <Container>
          <Label>Country</Label>
          <Select {...input} error={!!error}>
            <option value="" disabled>
              {placeholder}
            </option>

            {countries.map((country) => (
              <option key={country.id} value={country.id}>
                {country.name}
              </option>
            ))}
          </Select>

          {(error || meta.error) && meta.touched && (
            <Error>{error || meta.error}</Error>
          )}
        </Container>
      )}
      {...rest}
    />
  );
};

const Container = styled.div`
  position: relative;
  flex: 1;
`;

const Select = styled.select<{ error?: boolean }>`
  background-color: #1a1a1a;
  border: 1px solid ${props => (props.error ? "#FF5151" : "#333")};
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 16px;
  color: ${props => (props.value === "" ? "#777" : "#fff")}; /* 👈 placeholder-ը խամրած */
  width: 100%;
  height: ${props => (props.error ? 86 : 50)}px !important;
  appearance: none;
  cursor: pointer;

  option {
    color: #fff;
    background: #1a1a1a;
  }

  option[value=""] {
    color: #777; /* 👈 placeholder-ի գույն */
  }

  &:focus {
    outline: none;
    border-color: #fff;
  }
`;

const Label = styled.label`
  position: absolute;
  top: -8px;
  left: 16px;
  font-size: 14px;
  font-weight: 300;
  color: #888;
  background: linear-gradient(
    0deg,
    rgba(23, 23, 23, 1) 0%,
    rgba(26, 26, 26, 1) 100%
  );
`;

const Error = styled.span`
  font-size: 14px;
  line-height: 19px;
  color: #FF5151;
`;
